import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { IRedirect } from '../../../models/commonTypes';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
	}

	@computed
	get hasData(): boolean {
		const { tabsProps } = this.storeContext.tabsStore;

		if (tabsProps && tabsProps.breakpoints) {
			const tabComponents = tabsProps.breakpoints.filter(tab => tab.props && tab.props.tabComponents && tab.props.tabComponents.length > 0);
			return tabComponents.length > 0;
		}

		return (tabsProps && tabsProps.tabComponents && tabsProps.tabComponents.length > 0) || false;
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get initialActiveTab(): string | undefined {
		const activeTabQuery = this.appComponentConfiguration && this.appComponentConfiguration.activeTabManagement && this.appComponentConfiguration.activeTabManagement.initialValue;
		if (activeTabQuery) {
			return this.getQueryValue(activeTabQuery);
		}
	}

	@computed
	get urlRewrite(): IRedirect | undefined {
		return this.appComponentConfiguration && this.appComponentConfiguration.activeTabManagement && this.appComponentConfiguration.activeTabManagement.urlRewrite;
	}

}